import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { MyRecipient, MyRecipientRole } from 'projects/Administration/src/app/business-entities/notification-details-result-view-model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';
import { DealerDataService } from 'projects/Administration/src/app/data-services/dealer-data.service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-my-recipient',
  templateUrl: './my-recipient.component.html',
  styleUrls: ['./my-recipient.component.css']
})
export class MyRecipientComponent implements OnInit {
  myRecipientList: MyRecipient[] = [];
  dealerUserTypeList: any = [];
  editform:boolean=false;
  isDublicate:boolean=false;
  myRecipientRole: MyRecipientRole[] = [{
    roleId: 1,
    roleName: 'Admin'
  },
  {
    roleId: 2,
    roleName: 'Dealer'
  }]
  myRecipientModel: MyRecipient = {
    email: '',
    mobileCode: '',
    mobile: '',
    role: [],
    tag: '',
    userTypeId:0,
    isSelected:false,
    id:0,
    RoleName:'',
    DealerId:'',
    AppointmentId:'',
    DealerCommId:0,
    userName:''
  }
  defaultReceiptObject: MyRecipient;
  CountryISO = CountryISO;
  isInitialLoad: boolean[]= [];
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISO: any[]= [];

  constructor(
    private readonly activeModal: NgbActiveModal,
    public editAppointmentService: EditAppointmentService,
    private readonly service: DealerDataService,
    private readonly spinner: NgxSpinnerService,
    private readonly toastr: ToastrService,
    private readonly translate: TranslateService,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly settingService: SettingService
    ) { }

  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    if( this.editAppointmentService?.appointmentDetails?.dealerId){
      this.getNotificationDetailsByDealerId(this.editAppointmentService.appointmentDetails.dealerId);
    }
  }
  OnClose() {
    this.activeModal.close({success: false});
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  onCountryChange(obj3, idx) {
    if (this.isInitialLoad[idx] == undefined) {
    this.telInputObject(idx);
    this.myRecipientList[idx].mobileCode = this.myRecipientList[idx].mobileCode || obj3.dialCode;
    this.isInitialLoad[idx] = false;
    } else {
      this.myRecipientList[idx].mobileCode = obj3.dialCode;
    }
  }
  telInputObject(idx) {
    let mobileCode = this.myRecipientList[idx].mobileCode;
    if (mobileCode) {
      this.myRecipientList[idx].mobileCode = mobileCode.replace(/[+]/g, '');
      let countryCode = this.getCountryCodeByDialCode(mobileCode);
      this.selectedCountryISO[idx]= countryCode ? countryCode : this.cultureLocaleService.getLocale();
    }
    else{
      this.selectedCountryISO[idx]= this.cultureLocaleService.getLocale();
    }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }
  RemoveDealerNotification(index: number) {
    if(index > 0){
      if (this.myRecipientList.length > 1) {
        this.myRecipientList.splice(index, 1);
        this.selectedCountryISO.splice(index, 1);
        return;
      }
    }
    if(index === 0){
      this.myRecipientList[0].email = '';
      this.myRecipientList[0].mobile = '';
      this.myRecipientList[0].role = [];
      this.myRecipientList[0].userTypeId = 0;
      this.myRecipientList[0].tag = '';
      this.myRecipientList[0].isSelected = false;
      this.myRecipientList[0].RoleName = '';
      this.myRecipientList[0].DealerId = '';
      this.myRecipientList[0].AppointmentId = '';
      this.myRecipientList[0].DealerCommId = 0
      this.myRecipientList[0].userName = '';
      this.myRecipientList[0].id = 0;
    }
  }
  AddDealerNotification(_myRecipient:any,_index: number) {
    let myRecipientModel: MyRecipient = {
      email: '',
      mobileCode: '',
      mobile: '',
      role: this.dealerUserTypeList,
      tag: '',
      userTypeId:0,
      isSelected:false,
      id:0,
      RoleName:'',
      DealerId:'',
      AppointmentId:'',
      DealerCommId:0,
      userName:''
    }
    this.myRecipientList.push(myRecipientModel);
  }
  async getNotificationDetailsByDealerId(dealerId:string) {
    await this.service.getMyRecipientList(dealerId).then(result => {
      if (result) {
          this.editform = true;
          this.dealerUserTypeList = result.responseObject?.dealerUserTypeList;
          if(this.dealerUserTypeList && this.dealerUserTypeList.length > 0){
            this.myRecipientModel.role = this.dealerUserTypeList;
            if(result.responseObject?.dealerCommunicationDetail && result.responseObject?.dealerCommunicationDetail.length === 0){
              this.myRecipientList.push(this.myRecipientModel);
            }
            else{
              this.myRecipientList = result.responseObject?.dealerCommunicationDetail;
              this.myRecipientList.forEach(x=>{x.isSelected=false;
              x.userName = x.zIdent;
              })
            }
          }
      }
      this.spinner.hide();
    },
    _error => {
        this.spinner.hide()
      });
  }
  AddMyRecipient(){
    if(this.myRecipientList && this.myRecipientList.length > 0){
      this.myRecipientList.forEach((data)=>{
        const selectedRole = this.dealerUserTypeList.find(x=>x.userTypeId === data.userTypeId);
        data.RoleName = selectedRole?.name ?? "";
        data.DealerId = this.editAppointmentService.appointmentDetails.dealerId;
        data.AppointmentId = this.editAppointmentService.appointmentDetails.id;
        data.DealerCommId = selectedRole?.dealerCommId ?? 0;
        data.zIdent = data.userName;
        data.mobileCode= data.mobile?.dialCode ? data.mobile.dialCode.replace(/\+/g, '') : data.mobileCode;
        data.mobile= data.mobile?.number ? data.mobile.number.toString().replace(/\s+/g, '') : data.mobile;
      })
      let newRecipientList = this.myRecipientList.filter((a, i) => this.myRecipientList.findIndex(b => b.userName === a.userName && b.userTypeId === a.userTypeId) === i)
      if(newRecipientList && newRecipientList.length > 0){
        this.isDublicate = this.myRecipientList.length === newRecipientList.length
      }
      let isBlankUserName = this.myRecipientList.filter(x=> !x.userName).length > 0;
      let isBlankUserType = this.myRecipientList.filter(x=> !x.userTypeId).length > 0;
      if (isBlankUserType) {
        let msg = this.translate.instant("lblPleaseSelectUserType")
        this.toastr.error(msg);
      }
      else if (isBlankUserName) {
        let msg = this.translate.instant("lblUsernameisrequired")
        this.toastr.error(msg);
      }
      else if (this.isDublicate !== true) {
        let msg = this.translate.instant("lblDuplicaterecipientarenotallowed")
        this.toastr.error(msg);
      }
      else {
        this.spinner.show();
        this.service.AddRecipient(this.myRecipientList).then((res)=>{
          if (res.responseObject.result) {
            this.activeModal.close({ success: true });
          }
          else {
            const msg = this.translate.instant('lblFailedToSaveRecipient');
            this.toastr.error(msg);
          }
        }).finally(()=>{
          this.spinner.hide();
        })
      }
    }
  }
  ResetMyRecipient(){
    if(this.myRecipientList && this.myRecipientList.length > 0){
      this.myRecipientList = this.myRecipientList.filter(x=>x.id!==0);
      if(this.myRecipientList.length === 0){
      let myRecipientModel: MyRecipient = {
      email: '',
      mobileCode: '',
      mobile: '',
      role: this.dealerUserTypeList,
      tag: '',
      userTypeId:0,
      isSelected:false,
      id:0,
      RoleName:'',
      DealerId:'',
      AppointmentId:'',
      DealerCommId:0,
      userName:''
    }
    this.myRecipientList.push(myRecipientModel);
  }
    }
  }
  AddToNotification(){
    if(this.myRecipientList && this.myRecipientList.length > 0){
      this.myRecipientList.forEach((data)=>{
        const selectedRole = this.dealerUserTypeList.find(x=>x.userTypeId === data.userTypeId);
        data.mobileCode= data.mobile?.dialCode.replace(/\+/g, '') ?? data.mobileCode;
        data.mobile= data.mobile?.number ? data.mobile.number.toString().replace(/\s+/g, '') : data.mobile;
        data.RoleName = selectedRole?.name ?? "";
        data.DealerId = this.editAppointmentService.appointmentDetails.dealerId;
        data.AppointmentId = this.editAppointmentService.appointmentDetails.id;
        data.DealerCommId = selectedRole?.dealerCommId ?? "";
      })
      let selectedRecipient = this.myRecipientList.filter(x=>x.isSelected === true)
        this.spinner.show();
        this.service.AddToNotification(selectedRecipient).then((_res)=>{
          this.activeModal.close({ success: true
          });
          this.spinner.hide();
        })
        this.spinner.hide();
    }
  }
}
